module.exports = __webpack_public_path__ + "img/zhongxinyong.f9133d73.png";